import { useQuery } from '@tanstack/react-query';
import { trackError } from 'Utils/errorMonitoring';
import { getContact } from 'Services/invoices';

export default function useContact(contactId) {
    const { data: contact = {}, isLoading } = useQuery({
        queryKey: ['contact', contactId],
        queryFn: () => getContact(contactId),
        onError: (error) => trackError(error),
        enabled: !!contactId,
    });

    return {
        contact,
        isLoading,
    };
}
